module.exports = __webpack_public_path__ + "static/media/cprosCheck.d59e9766.svg";